import { TourPage } from '@/app/pages/tour-page/tour-page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const tourPageSearchSchema = z.object({
  period: z.number(),
  arrivalDate: z.string().optional(),
  departureDate: z.string().optional(),
  adults: z.number().min(1).max(10).optional(),
  childAges: z.array(z.number().min(0).max(17)).optional(),
  fromLanding: z.boolean().optional(),
  cityId: z.string().optional(),
});

export const Route = createFileRoute('/tour/$tourId')({
  validateSearch: tourPageSearchSchema,
  component: TourPage,
});
